import React, { useEffect } from 'react';

import Select from 'react-select';
import sortBy from 'lodash/sortBy';

import { useFetchData } from '../../../infrastructure/hooks/useFetchData';
import type { Tier } from '../../../schemas/VendorSchema';
import { ApiStatus } from '../../../infrastructure/constants/apiStatus';
import * as VendorsService from '../../../services/VendorsService';

type Props = {
  onSelect: (tier: Tier) => void;
  initialValue?: string | null;
  disabled?: boolean;
};

const getOptionLabel = (tier: Tier | undefined): string => {
  if (!tier) return '';

  return tier.id;
};
const getOptionValue = (tier: Tier): string => {
  return tier.pricingTableId ?? '';
};

const VendorTierSelector = (props: Props) => {
  const [fetchStatus, vendorTiers = [], fetchVendorTiers] = useFetchData<
    Tier[]
  >();

  useEffect(() => {
    fetchVendorTiers(() => VendorsService.getPricingTables());
  }, [fetchVendorTiers]);

  const initialValue = vendorTiers.find(
    tier => tier.pricingTableId === props.initialValue
  );

  const sortedVendorTiers = sortBy(vendorTiers, 'id');

  return (
    <Select
      isDisabled={props.disabled}
      options={sortedVendorTiers}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
      isLoading={fetchStatus === ApiStatus.loading}
      placeholder='Select Vendor Tier'
      value={initialValue}
      onChange={value => {
        if (!value) return;
        props.onSelect(value);
      }}
      className='select'
    />
  );
};

export default VendorTierSelector;
